import React from 'react';
import './index.css';
import { Steps, Badge } from 'antd-mobile';
import history from 'common/history'
import {
    connect
} from 'react-redux';
import {
    actionCreators
} from 'courseProjectStore';
import moment from "moment";
import NoContent from 'component/noContent';
import videoIcon from './img/icon_video.png';
import examIcon from './img/icon_exam.png';
import testIcon from './img/icon_test.png';
import lock from './img/lock.png';
import axios from 'axios';
import userRequest, {userApi} from 'common/request';

const Step = Steps.Step;

class StepTitle extends React.Component{
  pushClick(){
    if( this.props.pushClick instanceof Function){
      this.props.pushClick()
    }else{
      console.log('undefined')
    }
  }
  render(){
    const {data,type, permission, status} =  this.props;
    let tag = '';
    let src = videoIcon;
    if(type==='video'){
      tag = '视频课';
    }else if (type==='exam'){
      tag = '随堂测试';
      src = examIcon;
    }else if(type==='experi'){
      tag = '实验课';
      src = testIcon;
    }else{
      tag=type;
      src = '';
    }
    return(
        <div className="step-title" onClick={()=>{this.pushClick()}}>
          <div className="step-name">{data.title}</div>
          {/* {status.length > 0? <div className="step-name step-color">{data.title}</div> : <div className="step-name">{data.title}</div>} */}
          {/* <div className="step-name" className={data.id == this.props.sid?'active':''}>{data.title}</div> */}
          {/*<div className="step-tag">{tag}</div>*/}
          {data.DurationStr?<div className='learn'>{data.LearnTimeStr}/{data.DurationStr}</div>:null}
          <div className="step-icon">
            <img src={src} alt=''/>
          </div>
        </div>)
  }
}

class InfoCatalog extends React.Component{
  push(sid,content){
    const {id, permission} = this.props
    if (permission.userType == 'guest') return
    if(content&&content.type){
        if(content.type==='video'){
           history.push('/labroomvideo/courseid='+id+'&sid='+sid)
        }else if(content.type==='experi'){
          history.push('/labroomexper/courseid='+id+'&sid='+sid)
        }else if(content.type==='exam') {
           window.open(window.AppConfig.examUrl+'?exam-phone-callback&basicid='+content.basicid+'&subjectid='+sid+'&course_id='+id)
        }
    }else {
      console.log('content is null')
    }
  }

  stepTag(data, list, finishedListLock){
    let result = []
    finishedListLock.map(item => {
        if(!result[item.SubId]){
            result[item.SubId] = item.Auth
        }
    })

    for (let item of data) {
      let isLearnFinish = list.find(value => item.id==value)
      if(isLearnFinish !== undefined) {
        isLearnFinish ? item.isLearnFinish = true : item.isLearnFinish = false
      }else {
        item.isLearnFinish = false
      }
    }

    // console.log(data, ' course project data')
    console.log(list, 'finished list')

     if(data){
       return data.map((s,i) => {
        // if(result[s.id] && result[s.id] == 'succ'){
        //   return <Step key={i}
        //     title={
        //       <StepTitle pushClick={()=>{this.push(s.id,s.content)}} data={s}  type={s.content&&s.content.type?s.content.type:''}/>
        //     }
        //    icon={ <Badge text=" " style={{ height: 9, marginLeft: -5, padding: '0 3px', backgroundColor: '#24bfaf', borderRadius: '50%' }}></Badge>} />
        //  }else if(result[s.id] && result[s.id] == 'ing'){
        //     return <Step key={i}
        //      title={
        //        <StepTitle pushClick={()=>{this.push(s.id,s.content)}} data={s}  type={s.content&&s.content.type?s.content.type:''}/>
        //      }
        //     icon={ <Badge text=" " style={{ height: 9, marginLeft: -5, padding: '0 3px', backgroundColor: '#fff', borderRadius: '50%' , border: '1px solid #24bfaf'}}></Badge>} />
        //   }else if(result[s.id] && result[s.id] == 'wait') {
        //     return <Step key={i}
        //     title={
        //       <StepTitle pushClick={()=>{alert('课程未解锁')}} data={s}  type={s.content&&s.content.type?s.content.type:''}/>
        //     }
        //     icon={ <img src={lock}></img>} />
        //     // <img src={lock} style={{height: '1.5rem', marginLeft: '-5px'}}></img>
        //   }else {
        //     return <Step
        //     key={i}
        //     title={
        //       <StepTitle pushClick={()=>{this.push(s.id,s.content)}} data={s}  type={s.content&&s.content.type?s.content.type:''}/>
        //     }
        //    icon={ <img src={lock} style={{height: '1.5rem', marginLeft: '-5px'}}></img>} />
        //   }
         if(s.isLearnFinish === true){
          return <Step
            key={i}
            title={
              <StepTitle pushClick={()=>{this.push(s.id,s.content)}} data={s} status={''} type={s.content&&s.content.type?s.content.type:''}/>
            }
           icon={ <Badge text=" " style={{ height: 9, marginLeft: -5, padding: '0 3px', backgroundColor: '#24bfaf', borderRadius: '50%' }}></Badge>} />
         }else if(!s.Duration) {
           if(this.props.info.information_data !== null && 
            this.props.info.information_data.subject_lock !== undefined &&
            this.props.info.information_data.subject_lock == "1") {
            if(result[s.id] && result[s.id] == 'succ'){
              return <Step key={i}
                title={
                  <StepTitle pushClick={()=>{this.push(s.id,s.content)}} data={s} status={''} type={s.content&&s.content.type?s.content.type:''}/>
                }
               icon={ <Badge text=" " style={{ height: 9, marginLeft: -5, padding: '0 3px', backgroundColor: '#24bfaf', borderRadius: '50%' }}></Badge>} />
             }else if(result[s.id] && result[s.id] == 'ing'){
                return <Step key={i}
                 title={
                   <StepTitle pushClick={()=>{this.push(s.id,s.content)}} data={s} status={'ing'} type={s.content&&s.content.type?s.content.type:''}/>
                 }
                icon={ <Badge text=" " style={{ height: 9, marginLeft: -5, padding: '0 3px', backgroundColor: '#fff', borderRadius: '50%' , border: '1px solid #a5a5a5'}}></Badge>} />
              }else if(result[s.id] && result[s.id] == 'wait') {
                return <Step key={i}
                title={
                  <StepTitle pushClick={()=>{alert('课程未解锁')}} data={s} status={''} type={s.content&&s.content.type?s.content.type:''}/>
                }
                icon={ <img src={lock}></img>} />
                // <img src={lock} style={{height: '1.5rem', marginLeft: '-5px'}}></img>
              }else {
                return <Step
                key={i}
                title={
                  <StepTitle pushClick={()=>{this.push(s.id,s.content)}} data={s} status={''} type={s.content&&s.content.type?s.content.type:''}/>
                }
                // icon={ <Badge dot className="dot-finished"></Badge>} />
              icon={ <Badge text=" " style={{ height: 9, marginLeft: -5, padding: '0 3px', backgroundColor: '#fff', borderRadius: '50%' , border: '1px solid #a5a5a5'}}></Badge>} />
              }
           }else {
           return <Step
             key={i}
             title={
               <StepTitle pushClick={()=>{this.push(s.id,s.content)}} data={s} status={''} type={s.content&&s.content.type?s.content.type:''}/>
             }
             // icon={ <Badge dot className="dot-finished"></Badge>} />
           icon={ <Badge text=" " style={{ height: 9, marginLeft: -5, padding: '0 3px', backgroundColor: '#fff', borderRadius: '50%' , border: '1px solid #a5a5a5'}}></Badge>} />

           }
         } else {
            return <Step
            key={i}
            title={
              <StepTitle pushClick={()=>{this.push(s.id,s.content)}} status={'ing'} data={s}  type={s.content&&s.content.type?s.content.type:''}/>
            }
            // icon={ <Badge dot className="dot-finished"></Badge>} />
          icon={ <Badge text=" " style={{ height: 9, marginLeft: -5, padding: '0 3px', backgroundColor: '#fff', borderRadius: '50%' , border: '1px solid #24bfaf'}}></Badge>} />
         }
       })
    }
  }

  render(){
    const {subject, finishedList, finishedListLock} =this.props;
    let steps = ''
    if(subject&&subject.toJS()){
      steps = subject.toJS().map((s, i) => <Step key={i} title={s.title} description={s.description} />);
    }

    return (
      <div className="tab-catalog">
      {
        subject&&subject.size!=0
        ?
        subject.map((item,index)=>{
          return(
            <div className="catalog-list" key={index}>
                <div className="catalog-title">
                  <p className="list-icon">
                    <img src={require('./img/icon_catalog_title.png')} alt=""/>
                  </p>
                  <p className="list-name">第{index+1}章：
                  {
                    item.get('title')?item.get('title'):'暂无'
                  }</p>
                </div>
                {
                  item.get('childs')&&item.get('childs').size!=0?
                    item.get('childs').map((secitem,secindex)=>{
                      return(
                        <div key={secindex}>
                          <div className="section-title">
                            <span className="num">{secindex+1}.</span>
                            {
                              secitem.get('title')?secitem.get('title'):'暂无'
                            }
                          </div>
                          <div className="sub-main">
                            <Steps >
                              { this.stepTag(secitem.get('childs').toJS(), finishedList.toJS(), finishedListLock.toJS())}
                            </Steps>
                          </div>
                      </div>
                      )
                    })
                   :null
                }
              </div>
              )
        })
        :
        <NoContent/>

      }

      </div>
      )
  }
}




export default InfoCatalog ;
